export interface PipelineEntry {
  tradeName: string,
  partner: string,
  indicationShort: string,
  genericName: string,
  filingDate: string,
  combination: string,
  name: string,
  projectType: string,
  description: string,
  therapeuticArea: string,
  therapeuticAreaFilterValue: string,
  therapeuticAreaGroupByValue: string,
  phase: string,
  originalPhase: string,
  managedBy: string,
}

export interface FilterProps {
  attributeName: string,
  filter: unknown,
}

const filterWithMultipleFilters = (value:string, filters:string[]):
boolean => filters.some((entry) => entry === value);

export const FilterService = {
  filterByAttribute(
    data: PipelineEntry[],
    filter: FilterProps,
    splitFilterAt = '', // if left empty, it wont split
  ): PipelineEntry[] {
    return data.filter((entry) => {
      if (!filter.filter) {
        return true;
      }

      const targetAttribute = entry[filter.attributeName];
      if (!splitFilterAt) {
        return targetAttribute === filter.filter;
      }
      const filterValues = (filter.filter as string)?.split(splitFilterAt);
      return filterWithMultipleFilters(targetAttribute, filterValues);
    });
  },

  filterByAttributes(
    data: PipelineEntry[],
    filters: FilterProps[],
    splitFilterAt = '',
  ): unknown[] {
    let filteredData = data;

    filters.forEach((filter) => {
      filteredData = this.filterByAttribute(filteredData, filter, splitFilterAt);
    });

    return filteredData;
  },

  filterBySearchText(
    data: PipelineEntry[],
    searchText,
  ): unknown[] {
    if (!searchText) {
      return data;
    }
    const lowerCaseData = data.map((element) => Object.fromEntries(
      Object.entries(element).map(([key, value]) => [key, ((value as string) || '').toLowerCase()]),
    ));
    return lowerCaseData.map((dataEntry, index) => {
      const filteredElement = Object.values(dataEntry).find(
        (attributeText) => attributeText.includes(searchText.toLowerCase()),
      );
      return filteredElement ? data[index] : null;
    });
  },
};
